import axios from "axios";
import { userUpdateShowTravelerPath } from "../../paths";
import { config } from "../../config";

export const updateUserShowProfile = (
  body: IUserShowTravelerPayload
): Promise<IUserShowTravelerResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.put(userUpdateShowTravelerPath, body, {
        baseURL: config.baseURL,
      });

      const responseBody: IUserShowTravelerResponse = res.data;
      resolve(responseBody);
    } catch (e) {
      reject(e);
    }
  });

export interface IUserShowTravelerPayload {
  travelerId: string;
}

export interface IUserShowTravelerResponse { }

export default updateUserShowProfile;
